<template>
    <v-layout row v-if="customer.loyalty">
        <v-flex xs12>
            <v-tabs
                    centered light
                    v-if="customer.loyalty.nr_vouchers > 0"
                    v-model="model"
                    slider-color="primary">
                <v-tab
                        v-if="customer.loyalty.campaigns"
                        :key="1"
                        :href="`#tab-offers`">
                    <v-icon color="primary">fal fa-gift</v-icon>
                    {{ $vuetify.t('$vuetify.offers') }}
                </v-tab>
                <v-tab
                        v-if="customer.loyalty.nr_vouchers > 0"
                        :key="2"
                        :href="`#tab-vouchers`"
                >
                    <v-icon color="primary">fal fa-badge-percent</v-icon>
                    {{$vuetify.t('vouchers')}}
                </v-tab>

            </v-tabs>

            <v-tabs-items v-model="model">
                <v-tab-item
                        :key="1"
                        :value="`tab-offers`">

                    <v-spacer class="my-3"></v-spacer>

                    <v-layout align-center justify-center row>
                        <div id="points">
                            <h2 class="text-xs-center primary--text">{{ customer.loyalty.nr_points
                                }}</h2>
                            <h3 class="text-xs-center text-lowercase blue-grey--text text--lighten-4">
                                {{ $vuetify.t('$vuetify.points') }}</h3>
                        </div>
                    </v-layout>

                    <v-spacer class="my-3"></v-spacer>

                    <v-layout row wrap v-if="customer.loyalty.campaigns">
                        <v-flex xs12
                                v-for="campaign in customer.loyalty.campaigns"
                                :key="campaign.id"
                                v-bind:md6="campaign.priority !== 1"
                        >
                            <!--The card representing the Campaign can be defined with 3 elements:
                            1 - image   2 - title   3 - short description
                            It is mandatory to have an image or a title; the description is optional. -->
                            <v-card flat style="background: transparent">
                                <v-img v-if="campaign.image && baseUrl"
                                       v-bind:src="baseUrl + campaign.image">
                                    <!--<v-container fill-height fluid pa-2>
                                        <v-layout fill-height>
                                            <v-flex xs12 align-end flexbox>
                                                    <span v-if="campaign.name"
                                                          class="title primary--text font-weight-bold"
                                                          v-text="campaign.name"></span>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>-->
                                </v-img>
                                <!--@modified ana.castro 2019.05.30 SABO-910 -->
                                <!-- The campaigns with Priority High must have a differentiating style -->
                                <!--@modified ana.castro 2019.06.13 SCLAPP-12 -->
                                <!-- The campaigns the client CAN access to due to having enough Points should also have a differentiating style -->
                                <!-- The campaigns the client CAN NOT access to must be followed by the number of points missing to have access to the campaign -->
                                <v-card-title primary-title v-if="campaign.name">
                                    <div>
                                        <span v-if="campaign.priority === 1"
                                              class="headline primary--text font-weight-bold">
                                            {{campaign.name}}
                                        </span>
                                        <span v-else-if="campaign.available === 1"
                                              class="title primary--text font-weight-bold">
                                            {{campaign.name}}
                                        </span>
                                        <span v-else class="primary--text font-weight-bold">
                                            {{campaign.name}}
                                        </span>

                                        <br v-if="campaign.available === 0 && campaign.nr_points_to_achieve > 0">
                                        <span v-if="campaign.available === 0 && campaign.nr_points_to_achieve > 0"
                                              class="grey--text">
                                            {{ $vuetify.t('$vuetify.missing') }}{{campaign.nr_points_to_achieve}} {{ $vuetify.t('$vuetify.points') }}
                                        </span>
                                    </div>
                                </v-card-title>
                            </v-card>
                        </v-flex>
                    </v-layout>
                    <v-layout align-center justify-end row>
                        <div id="points_message">
                            <h6 v-if="this.offersGenericMessage"
                                class="text-xs-center blue-grey--text text--lighten-4">
                                {{ offersGenericMessage }}</h6>
                        </div>
                    </v-layout>
                </v-tab-item>

                <v-tab-item v-if="customer.loyalty.vouchers"
                            :key="2"
                            :value="`tab-vouchers`">
                    <v-layout row wrap>
                        <v-flex xs6 v-if="customer.loyalty.nr_vouchers < 0">
                            <div class="headline text-xs-center pa-5">
                                <h1>{{customer.loyalty.nr_vouchers}}</h1>
                                <br>
                                <h4 style="color: #9363cd">{{ $vuetify.t('$vuetify.vouchers.vouchers') }}</h4>
                            </div>
                        </v-flex>

                        <v-flex xs12>
                            <v-list
                                    v-for="voucher in customer.loyalty.vouchers"
                                    xs12
                                    :key="voucher.id"
                                    two-line>
                                <v-list-tile>
                                    <v-list-tile-action class="primary" v-if="voucher.start_date">
                                        <v-list-tile-title class="text-xs-center subheading text-lowercase white--text">
                                            {{voucher.start_date_month}}
                                        </v-list-tile-title>
                                        <v-list-tile-title class="text-xs-center title font-weight-bold  white--text">
                                            {{voucher.start_date_day}}
                                        </v-list-tile-title>
                                    </v-list-tile-action>

                                    <v-list-tile-content class="mr-2 ml-2" v-if="voucher.name">
                                        <v-list-tile-title>{{voucher.name}}</v-list-tile-title>
                                        <v-list-tile-sub-title> {{ $vuetify.t('$vuetify.vouchers.voucher_due_date') }}
                                            {{voucher.end_date}}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title v-if="voucher.valid_stores"> {{
                                            $vuetify.t('$vuetify.vouchers.voucher_available_at') }}
                                            {{voucher.valid_stores}}
                                        </v-list-tile-sub-title>
                                        <!--<v-list-tile-sub-title> {{ }}</v-list-tile-sub-title>-->
                                    </v-list-tile-content>

                                    <v-list-tile-action v-if="voucher.value">
                                        <v-list-tile-title class="text-xs-center headline font-weight-bold">
                                            {{voucher.value}}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title class="text-xs-center text-lowercase"> {{
                                            voucher.value_type}}
                                        </v-list-tile-sub-title>
                                        <!--<v-list-tile-sub-title> {{  }} </v-list-tile-sub-title>-->
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list>
                        </v-flex>
                    </v-layout>
                </v-tab-item>
            </v-tabs-items>
        </v-flex>
    </v-layout>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {userService} from '../../_services'
    import {getErrorMessage} from '../../_helpers'

    export default {
        name: "Offers",
        data() {
            return {
                model: 'tab-offers',
                customer: {}
            }
        },
        mounted() {
            this.$store.dispatch("loader/setLoading", true);

            userService.get().then(result => {
                    this.customer = result;
                    this.$log.debug(result);
                    this.$store.dispatch("loader/setLoading", false);
                },
                error => {
                    getErrorMessage(error, 'Getting Vouchers', this);
                }
            );
        },
        computed: {
            ...mapGetters({
                offersGenericMessage: 'configs/offersGenericMessage',
                baseUrl: 'configs/apiImgBaseUrl',
            })
        },
    }
</script>

<style scoped>
    .v-card__actions i {
        padding-right: 5px;
    }

    .v-tabs__item i {
        padding-right: 5px;
    }
</style>

